import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SbkPhoneNumberInputComponent } from './components/sbk-phone-number-input/sbk-phone-number-input.component';
import { InputTextModule } from '@backbase/ui-ang/input-text';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputValidationMessageModule } from '@backbase/ui-ang/input-validation-message';
import { SbkPayordValidationMessageComponent } from './components/sbk-payord-validation-message/sbk-payord-validation-message.component';
import { StoreModule } from '@ngrx/store';
import { LOADING_FEATURE_KEY, loadingReducer } from './store/loading.reducer';
@NgModule({
  imports: [
    CommonModule, InputTextModule,
    InputValidationMessageModule, ReactiveFormsModule, FormsModule,
    StoreModule.forFeature(LOADING_FEATURE_KEY, loadingReducer)
  ],
  declarations: [SbkPhoneNumberInputComponent, SbkPayordValidationMessageComponent],
  exports: [SbkPhoneNumberInputComponent, SbkPayordValidationMessageComponent],
})
export class SbkSharedModule { }
